export var DateFilterKey;
(function (DateFilterKey) {
    DateFilterKey["anytime"] = "Any time";
    DateFilterKey["yesterday"] = "Yesterday";
    DateFilterKey["previousweek"] = "Previous week";
    DateFilterKey["previousmonth"] = "Previous month";
})(DateFilterKey || (DateFilterKey = {}));
//# sourceMappingURL=DateFilters.js.map